import Column from '@components/column'
import Typography from '@components/typography'
import {
  BookCover,
  BookEntry,
  BookInfo,
  BookInformation,
  BookWrapper,
  DriverWrapper,
  HistoryLendHeader,
  HistoryLendToContainer,
  IssueDateBadge,
  LendDate,
  LendDateColumn,
  LendDateDetails,
  LenderName,
  ReturnDateBadge,
} from '../style'

import Row from '@components/row'
import SvgImage from '@components/svg'
import { IBookHistory } from '../type'
import DriveStatus from '../../../../components/status/driverStatus'
import Status from '@components/status'
import { format } from 'date-fns'

const HistoryInfo = ({
  history,
  type,
  onClick,
}: {
  history: IBookHistory
  type: 'Lend' | 'Borrow'
  onClick: (item: IBookHistory) => void
}) => {
  const bookData = history?.bookData
  const status =
    type === 'Lend'
      ? history?.status === 'Delivered'
        ? 'Book Lent'
        : history?.status === 'Returned'
          ? 'Book Returned'
          : history?.status
      : history?.status === 'Delivered'
        ? 'Book Borrowed'
        : history?.status === 'Returned'
          ? 'Book Returned'
          : history?.status

  const request = format(history.createdAt, 'dd-MMM')
  const issuedDate = history.issueDate
    ? format(history.issueDate, 'dd MMM, yyyy')
    : 'Not Assigned'
  const returnDate = history.returnDate
    ? format(history.returnDate, 'dd MMM, yyyy')
    : 'Not Assigned'
  const dueDays = Math.ceil(
    (new Date(history?.returnDate).getTime() - Date.now()) /
      (1000 * 60 * 60 * 24),
  )

  const dueDateText =
    dueDays < 0
      ? `${Math.abs(dueDays)} Due ${Math.abs(dueDays) === 1 ? 'Day' : 'Days'}`
      : dueDays > 0
        ? `${dueDays} ${dueDays === 1 ? 'Day' : 'Days'}`
        : 'No Due Date'

  return (
    <>
      <BookEntry
        onClick={() => {
          onClick(history)
        }}
      >
        <BookInformation>
          <BookWrapper>
            <BookCover
              src={`${process.env.BUCKET_URL}/${bookData?.coverImage}`}
              alt={bookData?.name}
            />
          </BookWrapper>
          <BookInfo>
            <Column styleColumn={{ width: '100%' }}>
              <Row justifyContent="space-between">
                <Typography size={14} variant="h3">
                  {bookData?.name}
                </Typography>
                <Status status={status} />
              </Row>

              <Typography size={12} tc="greyText">
                {bookData?.author}
              </Typography>
              <Typography size={10}>{bookData?.categoryData?.name}</Typography>
            </Column>
          </BookInfo>
        </BookInformation>

        <HistoryLendToContainer>
          <HistoryLendHeader>
            <LenderName>
              {type === 'Lend'
                ? `Lend to: ${history?.userCreated?.name}`
                : `Borrowed from: ${bookData?.userCreated?.name}`}
            </LenderName>
            <LendDate>Request: {request}</LendDate>
          </HistoryLendHeader>

          <LendDateDetails>
            <LendDateColumn>
              <p>Issue Date</p>
              <IssueDateBadge>{issuedDate}</IssueDateBadge>
            </LendDateColumn>
            {history?.status !== 'Returned' && history?.returnDate && (
              <LendDateColumn>
                <p>Days Left</p>
                <IssueDateBadge>{dueDateText}</IssueDateBadge>
              </LendDateColumn>
            )}
            <LendDateColumn>
              <p>Return Date</p>
              <ReturnDateBadge>{returnDate}</ReturnDateBadge>
            </LendDateColumn>
          </LendDateDetails>
        </HistoryLendToContainer>

        <DriverWrapper>
          <Row justifyContent="space-between">
            <Typography size={12}>Driver</Typography>
            {(history?.driverPickUp || history?.driverReturn) && (
              <DriveStatus
                status={
                  type === 'Borrow'
                    ? history?.actionStatus?.borrow
                      ? history?.actionStatus?.borrow
                      : history?.returnDriver?.id
                        ? 'Confirm Pickup'
                        : 'Confirm Delivery'
                    : history?.actionStatus?.lend
                      ? history?.actionStatus?.lend
                      : history?.returnDriver?.id
                        ? 'Confirm Delivery'
                        : 'Confirm Pickup'
                }
              />
            )}
          </Row>

          {history?.pickUpDriver ? (
            <Row colGap={10}>
              <SvgImage src={'delivery'} size={48} />
              <Column>
                <Typography size={12}>{history?.pickUpDriver?.name}</Typography>
                <Typography size={12}>
                  {history?.pickUpDriver?.id && 'Pick up Person'}
                </Typography>
                <Typography size={12}>
                  {history?.pickUpDriver?.phoneNo}
                </Typography>
              </Column>
            </Row>
          ) : (
            <Typography size={12} tc="greyText" styleText={{ margin: 'auto' }}>
              Pickup Person Not Assigned Yet!
            </Typography>
          )}
        </DriverWrapper>
      </BookEntry>
    </>
  )
}

export default HistoryInfo
